import { NgModule } from '@angular/core';
import { UpgradeCTADialogComponent } from './get-pro-dialog.component';

@NgModule({
  imports: [UpgradeCTADialogComponent],
  exports: [UpgradeCTADialogComponent],
})
export class UpgradeCTADialogModule {}
